import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchSessionData = createAsyncThunk("api/sessions", async () => {
  const response = await fetch(`${FULL_API_BASE_URL}/get-sessions-list`);
  const data = await response.json();
  return data.data;
});

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    sessionsData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSessionData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSessionData.fulfilled, (state, action) => {
        state.loading = false;
        state.sessionsData = action.payload;
      })
      .addCase(fetchSessionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default sessionSlice.reducer;
